import { useClassUnifiedApi } from "../api/ClassUnifiedApiClient";
import { ClassUnifiedFrontendService } from "../services/ClassUnifiedFrontendService";

export const useClassUnifiedService = (): ClassUnifiedFrontendService =>
  new ClassUnifiedFrontendService(useClassUnifiedApi());
